<template>
  <div class="message-mask" v-show="show">
    <div :class="{ message: true, disappear }" @transitionend="handleDisappeared">
      <div class="padding-container">
        <img :src="img" alt="icon" class="message__icon" />
        <div class="message__content">{{ content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    show: Boolean,
  },
  data() {
    return {
      // 用于控制消失动画
      disappear: false,
      img: require('@/assets/images/icon-attention.svg'),
    }
  },
  methods: {
    handleDisappeared() {
      this.$emit('update:show', false)
      this.disappear = false
    },
  },
  watch: {
    show(val) {
      if (val) {
        setTimeout(() => (this.disappear = true), 2000)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.message-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: transparent;
  z-index: 1000;
}

.message {
  width: 80%;
  height: 0;
  padding-top: 80%;
  position: fixed;
  text-align: center;
  top: calc(50% - 205px);
  left: 10%;
  border-radius: 17px;
  box-sizing: content-box;
  font-size: 14px;
  z-index: 1000;
  opacity: 1;
  transition: opacity 500ms;
  background-color: rgba(0, 0, 0, 0.5);

  .padding-container {
    margin-top: -100%;
    height: 100%;
    padding: 0 20px;
  }

  &__icon {
    width: 100px;
    height: 100px;
    margin: 10% auto 20%;
  }

  &__content {
    color: #fff;
    font-size: 18px;
    line-height: 35px;
    text-align: center;
  }

  &.disappear {
    opacity: 0;
  }
}
</style>
